import React from "react";
import "./Banner.css";

const Banner = () => {
  return <section className="banner-image"></section>;
};

export default Banner;
